<template>
  <div class="sidebar">

    <!-- Logo区域 -->
    <div class="logo-section">
      <div class="logo">
        <img style="width: 30px;height: 30px" src="../../assets/imgs/icon.png"></img>
        <span class="logo-text">动画精灵</span>
      </div>
    </div>

    <!-- AI创作按钮 -->
<!--    <div class="ai-create-btn">-->
<!--      <el-button type="primary" icon="el-icon-plus" size="medium">-->
<!--        AI创作-->
<!--      </el-button>-->
<!--    </div>-->

    <!-- 主导航菜单 -->
    <div class="main-menu">
      <div class="menu-item" :class="{ active: currentRoute === '/' }" @click="navigateTo('/')">
        <i class="el-icon-s-home"></i>
        <span>首页</span>
      </div>
      <div class="menu-item" :class="{ active: currentRoute === '/myScripts' }" @click="navigateTo('/myScripts')">
        <i class="el-icon-video-camera"></i>
        <span>个人动画</span>
      </div>
      <div class="menu-item" :class="{ active: currentRoute === '/myMaterials' }" @click="navigateTo('/myMaterials')">
        <i class="el-icon-folder-opened"></i>
        <span>个人素材</span>
      </div>
<!--      <div class="menu-item">-->
<!--        <i class="el-icon-share"></i>-->
<!--        <span>共享空间</span>-->
<!--        <span class="upgrade-tag">升级</span>-->
<!--      </div>-->
    </div>

<!--    &lt;!&ndash; 资源广场 &ndash;&gt;-->
<!--    <div class="resource-section">-->
<!--      <div class="section-title">资源广场</div>-->
<!--      <div class="menu-item">-->
<!--        <i class="el-icon-picture"></i>-->
<!--        <span>形象</span>-->
<!--      </div>-->
<!--      <div class="menu-item">-->
<!--        <i class="el-icon-headset"></i>-->
<!--        <span>音色</span>-->
<!--      </div>-->
<!--      <div class="menu-item">-->
<!--        <i class="el-icon-video-camera"></i>-->
<!--        <span>视频</span>-->
<!--      </div>-->
<!--      <div class="menu-item">-->
<!--        <i class="el-icon-medal"></i>-->
<!--        <span>品牌词范</span>-->
<!--        <span class="upgrade-tag">升级</span>-->
<!--      </div>-->
<!--      <div class="menu-item">-->
<!--        <i class="el-icon-star-off"></i>-->
<!--        <span>我的收藏</span>-->
<!--      </div>-->
<!--    </div>-->

<!--    &lt;!&ndash; Lab实验室 &ndash;&gt;-->
<!--    <div class="lab-section">-->
<!--      <div class="menu-item">-->
<!--        <i class="el-icon-cpu"></i>-->
<!--        <span>Lab实验室</span>-->
<!--      </div>-->
<!--    </div>-->

  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data() {
    return {
      currentRoute: '/'
    }
  },
  mounted() {
    this.currentRoute = this.$route.path
  },
  watch: {
    '$route'(to) {
      this.currentRoute = to.path
    }
  },
  methods: {
    navigateTo(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 175px;
  height: 100vh;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e5e7eb;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: auto;
}

.logo-section {
  padding: 20px 16px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-icon {
  font-size: 24px;
}

.logo-text {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.ai-create-btn {
  padding: 0 16px 16px;
}

.ai-create-btn .el-button {
  width: 100%;
  background: #6366f1;
  border-color: #6366f1;
  border-radius: 8px;
  font-weight: 500;
}

.ai-create-btn .el-button:hover {
  background: #5558e3;
  border-color: #5558e3;
}

.main-menu {
  padding: 0 8px;
}

.resource-section {
  padding: 0 8px;
  margin-top: 16px;
}

.section-title {
  padding: 8px 12px;
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin: 2px 0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  color: #4b5563;
  font-size: 14px;
  position: relative;
}

.menu-item:hover {
  background: #e5e7eb;
}

.menu-item.active {
  background: #e0e7ff;
  color: #4f46e5;
  font-weight: 500;
}

.menu-item i {
  font-size: 18px;
}

.upgrade-tag {
  position: absolute;
  right: 12px;
  background: #fef3c7;
  color: #d97706;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
}

.lab-section {
  margin-top: auto;
  padding: 8px;
  border-top: 1px solid #e5e7eb;
}

/* 滚动条样式 */
.sidebar::-webkit-scrollbar {
  width: 4px;
}

.sidebar::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 2px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}
</style>
